// match unique body_class
import Router from './util/Router';
import common from './routes/common';
import home from './routes/front-page';
import singleCareers from './routes/single-careers';
import archive from './routes/archive';
import pageTemplateLegal from './routes/legal';
import pageTemplateContact from './routes/contact';
import theSmartseat from './routes/the-smartseat';

/**
 * Populate Router instance with DOM routes
 *
 * @type {Router} routes - An instance of our router
 */
const routes = new Router( {
	common,
	home,
	singleCareers,
	archive,
	pageTemplateLegal,
	pageTemplateContact,
	theSmartseat
} );

/** Load Events */
routes.loadEvents();
